import { z } from 'zod';

import { RELEASE_TABS } from '~/modules/releaseNotes';

export const zodReleaseNotesSearchSchema = z.object({
  tab: z.enum(RELEASE_TABS).default('notes').catch('notes'),
});

export const releaseNotesSearchDefaults = zodReleaseNotesSearchSchema.parse({});
